import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"facebook\"><path fill=\"currentColor\" d=\"M11.483 19.441v-6.638h2.214l.421-2.746h-2.635V8.274c0-.751.369-1.483 1.549-1.483h1.197V4.454a14.804 14.804 0 0 0-2.123-.186c-2.171 0-3.588 1.315-3.588 3.695v2.093H6.103v2.745h2.413v6.639C3.334 18.621-.202 13.755.618 8.574 1.437 3.393 6.303-.143 11.483.676c5.183.82 8.719 5.685 7.898 10.866a9.497 9.497 0 0 1-7.898 7.899z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol